import { useEffect } from 'react';

export default function BuyCredits() {
  useEffect(() => {
    window.location.href = 'https://buy.stripe.com/eVq00j9ZDbxp8jU9Hg';
  }, []);

  return (
    <div style={{ 
      padding: '40px', 
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <h1>Redirecting to checkout...</h1>
      <p>
        If you're not redirected automatically,{' '}
        <a href="https://buy.stripe.com/eVq00j9ZDbxp8jU9Hg">
          continue to checkout
        </a>
      </p>
    </div>
  );
}